<div class="form-group">
  <label *ngIf="label" [for]="inputId" class="form-label">
    {{ label }}
    <span *ngIf="required" class="required-indicator">*</span>
  </label>

  <div class="input-wrapper"
       [class.input-with-icon]="hasIcon"
       [class.icon-left]="iconPosition === 'left'"
       [class.icon-right]="iconPosition === 'right'"
       [class.has-error]="hasError">
    <!-- Icon slot (left) -->
    <div *ngIf="hasIcon && iconPosition === 'left'" class="input-icon input-icon-left">
      <ng-content select="[slot=icon-left]"></ng-content>
    </div>

    <input
      [type]="type"
      [id]="inputId"
      [name]="name"
      [placeholder]="placeholder"
      [required]="required"
      [disabled]="disabled"
      [readonly]="readonly"
      [attr.minlength]="minLength"
      [attr.maxlength]="maxLength"
      [attr.min]="min"
      [attr.max]="max"
      [attr.pattern]="pattern"
      [attr.autocomplete]="autocomplete"
      [(ngModel)]="value"
      (input)="onInputChange($event)"
      (blur)="onInputBlur($event)"
      (focus)="onInputFocus($event)"
      class="form-control" />

    <!-- Icon slot (right) -->
    <div *ngIf="hasIcon && iconPosition === 'right'" class="input-icon input-icon-right">
      <ng-content select="[slot=icon-right]"></ng-content>
    </div>

    <!-- Clear button -->
    <button *ngIf="showClear" type="button" class="clear-button" (click)="onClear()" aria-label="Clear input">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <!-- Helper / hint text -->
  <div *ngIf="hint && !hasError" class="hint-text">
    {{ hint }}
  </div>

  <!-- Error message -->
  <div *ngIf="hasError" class="error-message">
    {{ errorMsg }}
  </div>
</div>
